import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { RegionalsSwgPromoPageProps } from './RegionalsSwgPromoPage'
import { LazyRegionalsSwgPromoPage } from './RegionalsSwgPromoPage.lazy'

type RegionalsSwgPromoPage = Omit<RegionalsSwgPromoPageProps, 'onEvent'>
export const RegionalsSwgPromoPageRegistration = createRegisterableComponent(
    'regionals-swg-promo-page',
    (props: RegionalsSwgPromoPage, services) => {
        return (
            <LazyRegionalsSwgPromoPage
                description={props.description}
                image={props.image}
                onEvent={services.onEvent}
            />
        )
    },
)
